// extracted by mini-css-extract-plugin
module.exports = {"centerImg":"successful_centerImg__BONF6","btnToMyorder":"successful_btnToMyorder__3Ez_0"};